import React, { useState } from "react";
import { validateEmail, validatePhone } from "../../../utils/validation";
import { trackNewsletterLead } from "~/sdk/leadTracking";

interface Props {
  onSuccess: () => void;
}

export const LightBoxForm = ({ onSuccess }: Props) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!validateEmail(email)) {
      setError("Por favor, insira um e-mail válido");
      setLoading(false);
      return;
    }

    if (!validatePhone(phone)) {
      setError("Por favor, insira um telefone válido com DDD");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("/api/dataentities/NW/documents", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          nome: name,
          phone,
        }),
      });

      if (!response.ok) {
        throw new Error("Não foi possível cadastrar. Tente novamente mais tarde.");
      }

      const data = await response.json();

      if (data.DocumentId) {
        void trackNewsletterLead({ source: "lightbox_popup", email, phone });
        localStorage.setItem("LightBox", "true");
        setName("");
        setEmail("");
        setPhone("");
        onSuccess();
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Ocorreu um erro ao cadastrar",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-8 pt-10 pb-4 px-4 lg:pt-[61.5px] lg:pb-[41.5px] lg:px-10">
      <div className="flex flex-col max-w-[307px] lg:max-w-[351px]">
        <p className="font-['Poppins'] font-normal text-xl leading-6 tracking-normal text-center align-middle uppercase text-[#1A1A1A] m-0">Cadastre-se na nossa</p>
        <p className="font-['Poppins'] font-bold text-xl leading-6 tracking-normal text-center align-middle uppercase text-[#1A1A1A] m-0">Newsletter</p>
        <p className="font-['Poppins'] font-normal text-xs leading-[16.8px] tracking-normal text-center align-middle m-0 mt-0.5 text-[#1A1A1A]">Receba as novidades e ganhe <span className="font-['Poppins'] font-bold text-xs leading-[16.8px]">10% de desconto</span> na primeira compra</p>
      </div>

      <form onSubmit={onSubmit} className="flex flex-col gap-6 max-w-[307px] lg:max-w-[351px]">
        {error && (
          <p className="font-['Poppins'] text-xs text-red-500">{error}</p>
        )}
        <input
          type="text"
          name="name"
          id="name"
          placeholder="Nome"
          required
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
          className="p-2.5 border border-[#C9C9C9] bg-white font-['Poppins'] font-normal text-sm leading-none tracking-normal align-middle text-[#434343] placeholder-[#434343]"
        />
        <input
          type="email"
          name="email"
          id="email"
          placeholder="E-mail"
          required
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
          className="p-2.5 border border-[#C9C9C9] bg-white font-['Poppins'] font-normal text-sm leading-none tracking-normal align-middle text-[#434343] placeholder-[#434343]"
        />
        <input
          type="tel"
          name="phone"
          id="phone"
          placeholder="Telefone"
          required
          value={phone}
          onChange={(e) => setPhone(e.currentTarget.value)}
          className="p-2.5 border border-[#C9C9C9] bg-white font-['Poppins'] font-normal text-sm leading-none tracking-normal align-middle text-[#434343] placeholder-[#434343]"
        />
        <button
          type="submit"
          disabled={loading}
          className="mt-1 font-['Poppins'] font-bold text-base leading-[17px] tracking-[5.2px] text-center align-middle uppercase text-white bg-[#1E1E1E] w-full py-4 disabled:opacity-60 disabled:cursor-not-allowed hover:bg-[#C18A58] hover:text-[#1A1A1A]"
        >
          {loading ? "Cadastrando..." : "Cadastre-se"}
        </button>
      </form>

      <ul className="flex flex-col gap-1 max-w-[307px] lg:max-w-[351px] list-inside list-disc">
        <li className="font-['Poppins'] font-normal text-[10px] leading-[15px] tracking-normal align-middle text-[#434343]">Assinando nossa news, você está de acordo com a nossa <a href="/institucional/aviso-de-privacidade" className="font-['Poppins'] font-normal text-[10px] leading-[15px] tracking-normal align-middle underline decoration-solid text-[#434343]">Política de Privacidade</a></li>
        <li className="font-['Poppins'] font-normal text-[10px] leading-[15px] tracking-normal align-middle text-[#434343]">Não enviamos spam. Você pode cancelar quando quiser.</li>
      </ul>
    </div>
  );
};
